export default "__VITE_ASSET__8$ay2H96__"